import { useEffect } from "react";
import { HomeHeader, HomeFooter } from "@/components/home/HomeChrome";
import { Hero } from "@/components/home/Hero";
import { WhyFabricators } from "@/components/home/WhyFabricators";
import { HowItWorks } from "@/components/home/HowItWorks";

export default function Home() {
  useEffect(() => {
    const prev = document.title;
    document.title = "SteelForgeAI — Spec, Contract & Addendum Review for Structural Steel Fabricators";
    return () => { document.title = prev; };
  }, []);
  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-100" data-testid="home-page">
      <HomeHeader />
      <main>
        <Hero />
        <HowItWorks />
        <WhyFabricators />
      </main>
      <HomeFooter />
    </div>
  );
}
